<!-- 页脚 -->
<template>
  <div class="main">
    <div class="footer">
      <div class="f-bottom">
        <div>
          <a href="//beian.miit.gov.cn/" target="_blank">沪ICP备2023034837号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myFooter',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #1f1f1f;

  .footer {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 40px 0;

    .f-logo {
      width: 117px;
      height: 80px;
    }

    .f-center {
      display: flex;
      justify-content: space-between;
      padding: 90px 130px 150px;
      color: #fff;
      font-size: 20px;

      img {
        width: 44px;
        height: 31px;
      }

      .f-slogan {
        flex: 1;
        margin-left: 30px;
      }

      .f-btn {
        width: 160px;
        height: 48px;
        color: #333;
        font-size: 16px;
      }
    }

    .f-bottom {
      display: flex;
      justify-content: center;
      color: #fff;
      font-size: 14px;

      a {
        color: #fff;
      }
    }
  }
}
</style>
